import { useCallback } from 'react'
import { AgxDropdown, AgxRow, AgxTextInput } from '@urbanx/agx.ui-components2'
import { Deposit, DepositValueType } from '@urbanx/agx.campaigns.client'
import { parseNumber } from 'utils/parseNumber'

export const QldDepositOptions = [
  { label: DepositValueType.Dollar, value: DepositValueType.Dollar },
  { label: DepositValueType.Percentage, value: DepositValueType.Percentage },
]

interface QldDepositOptionsProps {
  id: string
  depositValue: DepositValueType
  onDepositValueChange: (value: DepositValueType) => void
  onDepositChange: (updater: (prev: Deposit | undefined) => Deposit) => void
}

export function QldDepositOptionsComponent({
  id,
  depositValue,
  onDepositValueChange,
  onDepositChange,
}: QldDepositOptionsProps) {
  const handleAmountChange = useCallback(
    (value: string | undefined) => {
      if (depositValue === DepositValueType.Percentage) {
        onDepositChange((prev) => ({
          ...prev,
          percent: value ? parseNumber(value) : undefined,
          amount: undefined,
          depositValueType: DepositValueType.Percentage,
        }))
      } else {
        onDepositChange((prev) => ({
          ...prev,
          amount: value ? parseNumber(value) : undefined,
          percent: undefined,
          depositValueType: DepositValueType.Dollar,
        }))
      }
    },
    [depositValue, onDepositChange]
  )

  return (
    <AgxRow gap="spacing-md" fill>
      <AgxDropdown
        options={QldDepositOptions}
        id={`select-${id}`}
        onChange={(value) => onDepositValueChange(value as DepositValueType)}
        selected={depositValue}
        hideOptionalText
        required
      />
      {depositValue === DepositValueType.Percentage && (
        <AgxTextInput
          id={`${id}-amount`}
          type="percent"
          stretch
          hideOptionalText
          onChange={handleAmountChange}
        />
      )}
      {depositValue === DepositValueType.Dollar && (
        <AgxTextInput
          id={`${id}-amount`}
          type="currency"
          stretch
          hideOptionalText
          onChange={handleAmountChange}
        />
      )}
    </AgxRow>
  )
}
